<template lang="pug">
section.sidebar#aside
  aside
    div
      .menu
        ul.menu-list
          li(v-if="user.access.account")
            router-link(
              :to="{ name: 'account' }"
              :class="{ 'is-active': activePage === 'account' }"
            )
              b-tooltip(label="Account" type="is-dark" position="is-right")
                b-icon(icon="settings")
          //- li
          //-   router-link(
          //-     :to="{ name: 'pages' }"
          //-     :class="{ 'is-active': activePage === 'pages' }"
          //-   )
          //-     b-tooltip(label="Pages" type="is-dark" position="is-right")
          //-       b-icon(icon="file-document-box-multiple-outline")
          li(v-if="user.access.media")
            router-link(
              :to="{ name: 'media' }",
              :class="{ 'is-active': activePage === 'media' }"
            )
              b-tooltip(label="Media" type="is-dark" position="is-right")
                b-icon(icon="podcast")
          li(v-if="user.access.events")
            router-link(
              :to="{ name: 'events' }"
              :class="{ 'is-active': activePage === 'events' || activePage === 'event_registrations' || activePage === 'event_form' }"
            )
              b-tooltip(label="Events" type="is-dark" position="is-right")
                b-icon(icon="calendar-multiple")
          li(v-if="user.access.users")
            router-link(
                :to="{ name: 'users' }"
                :class="{ 'is-active': activePage === 'users' }"
            )
              b-tooltip(label="User Managment" type="is-dark" position="is-right")
                b-icon(icon="account-check")
          li(v-if="user.access.church")
            router-link(
                :to="{ name: 'ministries' }"
                :class="{ 'is-active': activePage === 'ministries' || activePage === 'ministry' }"
              )
              b-tooltip(label="Church" type="is-dark" position="is-right")
                b-icon(icon="church")
          li(v-if="user.access.articles")
            router-link(
              :to="{ name: 'articles' }"
              :class="{ 'is-active': activePage === 'articles' || activePage === 'article' }"
            )
              b-tooltip(label="Articles" type="is-dark" position="is-right")
                b-icon(icon="fountain-pen-tip")
    a.logout(@click="logout")
      b-icon(icon="power")
</template>

<script>
import { mapGetters } from 'vuex';
import { HTTP } from '@/utils/http';
import Avatar from 'vue-avatar';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';

export default {
  name: 'DxAside',
  components: {
    Avatar,
  },
  computed: {
    ...mapGetters({
      user: getters.GET_AUTHENTICATED_USER,
      authenticated: getters.GET_IS_AUTHENTICATED,
      account: getters.GET_ACCOUNT,
    }),
    activePage() {
      return this.$route.name;
    },
    comment() {
      return this.comments[Math.floor(Math.random() * this.comments.length)];
    },
    greeting() {
      return this.greetings[Math.floor(Math.random() * this.greetings.length)];
    },
  },
  data() {
    return {
      greetings: [
        'Hi',
        'Hola',
        'Ciao',
        'Guten tag',
        'Hey',
        'Hello',
        'Ahoy',
        'Greetings',
      ],
      comments: [
        'Looking good today',
        'You\'re not in Kansas anymore',
        'Ready for your close-up?',
        'May the Force be with you',
        'You\'re gonna need a bigger boat',
      ],
    };
  },
  methods: {
    async logout() {
      await HTTP.delete('/tokens');
      await this.$store.dispatch(actions.DO_LOGOUT);
      this.$router.push('/login');
    },
  },
};
</script>

<style lang="scss">
  #app {
    &.is-authenticated {
      #aside {
        left: 0;
      }
    }
  }
  #aside {
    position: fixed;
    left: -100px;
    width: $aside-width;
    transition: left 0.35s ease-in-out;
  }
  section.sidebar {
    padding: 1rem 0.5rem;
    min-height: 100vh;
    height: 100vh;
    background-color: $theme-primary;
    z-index: 5;
    aside {
      height: 100%;
      display: flex;
      flex-flow: column;
      justify-content: space-between;
    }
    .media {
      margin-bottom: 1.5rem;
      align-items: center;
      .media-content {
        > span {
          display: block;
          line-height: 100%;
        }
      }
    }
    .menu-list {
      li {
        padding: 0.25rem 0;
        a {
          color: $blue-light;
          &:hover {
            background-color: transparent;
            color: $white;
          }
          &.is-active {
            color: $white;
          }
        }
        .icon + span {
          position: relative;
          top: -3px;
          left: 5px;
        }
      }
    }
    a.logout {
      color: $blue-light;
      text-align: center;
      &:hover {
        background-color: transparent;
        color: $white;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Aside.vue